import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CloseIconWhite from 'assets/icons/close-icon-white.png'
import LogoutIcon from 'assets/icons/logout-icon.svg'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import { userSelector, userIdSelector } from 'src/selectors'
import IcoPoll from 'assets/icons/ico-poll.png'
import IcoCrown from 'assets/icons/ico-crown.png'
import IcoChat from 'assets/icons/ico-chat.png'
import BalloonIconWhite from 'assets/icons/balloon-icon-white.png'
import PropTypes from 'prop-types'
import { logout } from 'src/actions/login'
import { routerActions } from 'react-router-redux'
import styles from './profile-panel.scss'
import { fullName as userFullName } from 'src/services/user_helpers'
import MembershipInfo from 'components/MenuBar/membership-info/MembershipInfo'
import { PlanType, getPlanTypeBySlug } from 'src/services/stripe_checkout_configs'
import Button from 'src/components/common/Button'
import {
  PurchaseWorkflowNode,
  setCheckoutModalOpen,
  setDefaultWorkflowNode
} from 'src/actions/stripeCheckout'
import HobnobModal from 'src/components/common/HobnobModalV2/HobnobModal'
import { DOWNLOAD_APP_LINK } from 'src/constants'
import SvgIcon from 'src/components/common/SvgIcon'
import PopConfirm from 'components/common/PopConfirm/PopConfirm'

const ProfilePanel = props => {
  const { onClose } = props
  const dispatch = useDispatch()
  const user = useSelector(userSelector) || {}
  const userId = useSelector(userIdSelector)
  const currentSub = user.current_subscription

  // const communityList = useSelector(communityListSelector)

  const [downloadModalVisible, setDownloadModalVisible] = useState(false)
  const [logoutConfirmVisible, setLogoutConfirmVisible] = useState(false)

  const userName = userFullName(user)
  let isFreePlan = true
  let isFreTrailUsed = true

  if (currentSub) {
    const planType = getPlanTypeBySlug(currentSub.plan.slug)
    isFreTrailUsed = !user.is_trial_available
    isFreePlan = planType === PlanType.Free
  }

  const handleLogOut = () => {
    if (user) {
      dispatch(logout())
    } else {
      dispatch(routerActions.push('/login'))
    }
    onClose()
  }

  const navigationPage = url => {
    dispatch(routerActions.push(url))
    onClose()
  }

  const startPlanCheckout = () => {
    dispatch(setDefaultWorkflowNode(PurchaseWorkflowNode.PurchasePlanOnMobileApp))
    dispatch(setCheckoutModalOpen(true))
  }

  return (
    <div className={styles['profile-panel-container']}>
      <div className={styles['header-container']}>
        <div className={styles['icon-wrapper']}>
          <img src={CloseIconWhite} width="24" alt="Close" onClick={onClose} />
          <SvgIcon
            icon={LogoutIcon}
            width={24}
            height={24}
            onClick={() => setLogoutConfirmVisible(true)}
          />
        </div>
        <div className={styles['avatar']}>
          <UserAvatarContainer user={user} size={50} />
          <div className={styles['name']}>{userName}</div>
        </div>
        <div className={styles['plan']}>
          <MembershipInfo mobileProfilePanel />
          {isFreePlan && (
            <Button className={styles['purchase-button']} onClick={startPlanCheckout}>
              {isFreTrailUsed ? 'Subscribe' : 'REDEEM YOUR FREE WEEK'}
            </Button>
          )}
        </div>
      </div>
      <div className={styles['content-container']}>
        <div className={styles['group-container']}>
          <div className={styles['group-name']}>HOBNOB</div>
          <ul className={styles['list-container']}>
            <li className={styles['list-item']} onClick={() => navigationPage('/tp/timepoll')}>
              <img src={IcoPoll} width="28" alt="" />
              <span>Polls & Lists</span>
            </li>
            <li className={styles['list-item']} onClick={() => navigationPage('/e/list')}>
              <img src={BalloonIconWhite} width="28" alt="" />
              <span>Events & Announcements</span>
            </li>
            <li
              className={styles['list-item']}
              onClick={() => {
                setDownloadModalVisible(true)
                window.mixpanel.track('Chat Clicked', { user_id: userId })
              }}
            >
              <img src={IcoChat} width="28" alt="" />
              <span>Chat</span>
            </li>
            {!isFreePlan && (
              <li className={styles['list-item']} onClick={() => navigationPage('/membership')}>
                <img src={IcoCrown} width="28" alt="" />
                <span>Membership</span>
              </li>
            )}
          </ul>
        </div>

        {/* <div className={styles['group-container']}>
            <div className={styles['group-name']}>SPACE</div>
            <ul className={styles['list-container']}>
              {communityList.map(item => {
                return (
                  <li className={styles['list-item']} key={item.id}>
                    <div
                      className={styles['community-tag']}
                      style={{
                        backgroundColor: styles[item.community_color.color_value.replace(/_/g, '-')]
                      }}
                    >
                      {item.community_initials}
                    </div>
                    <span>{item.name}</span>
                  </li>
                )
              })}
              <li
                className={styles['list-item']}
                onClick={() => message.info('Please download the HobnobÏ App to use this feature.')}
              >
                <img src={IcoCreate} width="32" alt="" />
                <span>Create a Private Space</span>
              </li>
            </ul>
          </div> */}
      </div>

      <HobnobModal visible={downloadModalVisible} onCancel={() => setDownloadModalVisible(false)}>
        <div className={styles['download-container']}>
          <div className={styles['title']}>To Chat, Get the App</div>
          <div>
            Hobnob makes group chats pain-free and private! Download Hobnob to direct message any
            guest on the guest list.
          </div>
          <Button
            wrapperElement={'a'}
            href={DOWNLOAD_APP_LINK}
            target="_blank"
            className={styles['button-inner']}
            onClick={() => window.mixpanel.track('GET HOBNOB TO CHAT Clicked', { user_id: userId })}
          >
            GET HOBNOB TO CHAT
          </Button>
        </div>
      </HobnobModal>

      <PopConfirm
        visible={logoutConfirmVisible}
        onClose={() => setLogoutConfirmVisible(false)}
        cancelText="No"
        confirmText="Yes"
        type="cancel"
        cancelType="normal"
        onConfirm={handleLogOut}
      >
        Are you sure you want to log out?
      </PopConfirm>
    </div>
  )
}

ProfilePanel.propTypes = {
  // communityList: PropTypes.array,
  onClose: PropTypes.func
}

export default ProfilePanel
